import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import DeleteModal from "./DeleteModal";
import { useDispatch } from "react-redux";
import {
  challengesStatus,
  getChallenges,
} from "../../../features/slices/challanges";
import { useSelector } from "react-redux";
import CommonPagination from "../../CommonPagination";
import TableSkeleton from "../../TableSkeleton";
import ExportToExcel from "../../ExportToExcel";
import moment from "moment";
import { toastService } from "../../../utils/toastify";
import { canPerformAction } from "../../../utils/denyAccess";
const initialState = {
  deleteModalState: false,
  fromDate: "",
  toDate: "",
  timeframe: "",
  searchQuery: "",
  category: "",
};
const Upcoming = () => {
  const [iState, setUpdateState] = useState(initialState);
  const [upComingData, setUpcomingData] = useState("");
  const {
    searchQuery,
    fromDate,
    toDate,
    timeframe,
    category,
    deleteModalState,
  } = iState;
  const { challenges, loading } = useSelector((state) => {
    return state.challenges;
  });
  const [page, setPage] = useState(1);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const upcomingRef = useRef();
  const dispatch = useDispatch();
  const handleSubmit = () => {
    const queryParams = {
      page: 1,
      type: "Upcoming",
    };
    if (fromDate && toDate) {
      queryParams.startDate = fromDate;
      queryParams.endDate = toDate;
    } else if (timeframe) {
      queryParams.timeframe = timeframe;
    }

    dispatch(getChallenges(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
      }
    });
  };
  const handleTimeFrame = (e) => {
    const queryParams = {
      timeframe: e.target.value,
      type: "Upcoming",
    };
    setUpdateState((prev) => ({
      ...prev,
      timeframe: e.target.value,
    }));
    dispatch(getChallenges(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        // setUpdateState((prev) => ({
        //   ...prev,
        //   timeframe: "",
        // }));
      }
    });
  };
  const handleReset = () => {
    setUpdateState(initialState);
    dispatch(getChallenges({ page, type: "Upcoming" }));
  };
  useEffect(() => {
    dispatch(getChallenges({ type: "Upcoming" }));
  }, [page]);
  useEffect(() => {
    if (searchQuery?.trim() !== "") {
      const delayDebounceFunc = setTimeout(() => {
        dispatch(
          getChallenges({ search: searchQuery?.trim(), type: "Upcoming" })
        ).then((res) => {
          if (res?.payload?.code == 200) {
            // setUpdateState((prev) => ({
            //   ...prev,
            //   searchQuery: "",
            // }));
          }
        });
      }, 1000);
      return () => clearTimeout(delayDebounceFunc);
    }
  }, [searchQuery, dispatch]);
  const handleSearch = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeCategory = (e) => {
    setUpdateState((prev) => ({
      ...prev,
      category: e.target.value,
    }));
    dispatch(getChallenges({ categoryId: e.target.value, type: "Upcoming" }));
  };
  const handleDeleteModal = (res) => {
    setUpcomingData(res);
    setUpdateState((prev) => ({
      ...prev,
      deleteModalState: true,
    }));
  };
  const handleStatus = (e, id) => {
    const value = e.target.checked ? "ACTIVE" : "INACTIVE";
    const data = { id: id, status: value };
    dispatch(challengesStatus(data)).then((data) => {
      if (data?.payload?.code === 200) {
        dispatch(getChallenges({ type: "Upcoming", page })).then((data) => {
          if (data?.payload?.code === 200) {
            toastService.success("Status updated successfully");
            setUpdateState((prev) => ({
              ...prev,
              status: "",
            }));
          } else {
            toastService.error(data?.payload?.message);
          }
        });
      }
    });
  };
  return (
    <>
      {challenges?.result?.[0]?.paginationData?.length > 0 ? (
        <div className="tab-pane fade active show" id="Upcoming">
          <div className="FilterArea">
            <div className="FilterLeft">
              <div className="form-group">
                <label>From Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  disabled={timeframe}
                  name="fromDate"
                  onChange={(e) => handleSearch(e)}
                />
              </div>
              <div className="form-group">
                <label>To Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="toDate"
                  value={toDate}
                  disabled={timeframe}
                  onChange={(e) => handleSearch(e)}
                />
              </div>
              <div className="form-group">
                <label>&nbsp;</label>
                <button className="Button" onClick={handleSubmit}>
                  Apply
                </button>
              </div>
              <div className="form-group">
                <label>Timeframe</label>
                <select
                  className="form-control customSelect"
                  name="timeframe"
                  value={timeframe}
                  disabled={fromDate || toDate}
                  onChange={(e) => handleTimeFrame(e)}
                >
                  <option value="" hidden>
                    Select
                  </option>
                  <option value="Today">Today</option>
                  <option value="Week">This Week</option>
                  <option value="Month">This Month</option>
                </select>
              </div>
            </div>
          </div>
          <div className="NewFilter">
            <div className="SearchBox">
              <input
                type="search"
                className="SearchInput"
                placeholder="Search here by ID, Name, or Others"
                name="searchQuery"
                value={searchQuery}
                onChange={(e) => handleSearch(e)}
              />
              <span>
                <i className="fa fa-search" />
              </span>
            </div>
            <div className="Actions">
              <div
                className="form-group"
                style={{
                  textAlign: "center",
                }}
              >
                {/* <button className="FilterBtn">
                  <span>
                    <img src={require("../../../assets/images/filter.png")} />
                  </span>
                  Filters */}
                <select
                  className="form-control FilterStatus"
                  name="category"
                  value={category}
                  onChange={(e) => handleChangeCategory(e)}
                >
                  <option value="" hidden>
                    Filter by category
                  </option>
                  {challenges?.result?.[0]?.paginationData?.map((res, i) => {
                    return (
                      <option value={res?.categoryId} key={i}>
                        {res?.categoryData?.[0]?.categoryName}
                      </option>
                    );
                  })}
                </select>
                {/* </button> */}
              </div>
              <button className="Button Cancel" onClick={handleReset}>
                <i className="fa fa-refresh" />
              </button>
              <ExportToExcel
                ref={upcomingRef}
                fileName="upcomingChallangesData"
              />
            </div>
          </div>
          <div className="TableList">
            <table className="table-hover" ref={upcomingRef}>
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Challenge Id</th>
                  <th>Challenge Title</th>
                  <th>Category</th>
                  <th>Start Date</th>
                  <th>Deadline Date</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <TableSkeleton />
                ) : (
                  challenges?.result?.[0]?.paginationData?.map((res, i) => {
                    return (
                      <tr key={res?._id}>
                        <td>{i + 1 + (page - 1) * 10}</td>
                        <td>{res?.challenge_number}</td>
                        <td>{res?.title}</td>

                        <td>{res?.categoryData?.[0]?.categoryName}</td>
                        <td>{moment(res?.startDate).format("YYYY/MM/DD")}</td>
                        <td>{moment(res?.endDate).format("YYYY/MM/DD")}</td>
                        <td>
                          <span
                            className={`${
                              res?.status == "ACTIVE" ? "Green" : "Red"
                            }`}
                          >
                            {res?.status == "ACTIVE" ? "Available" : "Removed"}
                          </span>
                        </td>
                        <td>
                          <div className="Actions">
                            {canPerformAction("Challenges&Bounty") && (
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={res?.status == "ACTIVE"}
                                  name="status"
                                  onChange={(e) => handleStatus(e, res?._id)}
                                />
                                <span className="slider" />
                              </label>
                            )}
                            <Link
                              to="challengesDetails"
                              state={res}
                              className="Eyes"
                            >
                              <i className="fa-regular fa-eye" />
                            </Link>
                            {canPerformAction("Challenges&Bounty") && (
                              <>
                                <Link
                                  to={"editUpcoming"}
                                  className="Edit"
                                  state={res}
                                >
                                  <i className="fa-regular fa-pen-to-square" />
                                </Link>
                                <a
                                  className="Delete"
                                  onClick={() => handleDeleteModal(res)}
                                >
                                  <i className="fa-regular fa-trash-can" />
                                </a>
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
          <div className="Pagination">
            <p>
              Showing {(page - 1) * 10 + 1} to{" "}
              {challenges?.result?.[0]?.paginationData?.length +
                (page - 1) * 10}{" "}
              of {challenges?.result?.[0]?.totalCount?.[0]?.count} results
            </p>
            <div className="PaginationRight">
              {challenges?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                <CommonPagination
                  activePage={page}
                  itemsCountPerPage={10}
                  totalItemsCount={
                    challenges?.result?.[0]?.totalCount?.[0]?.count || 0
                  }
                  pageRangeDisplayed={4}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                />
              )}
            </div>
          </div>
        </div>
      ) : (
        <p
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "white",
            height: "200px",
            color: "green",
          }}
        >
          No upcoming challange Yet! Please add a new challange
        </p>
      )}
      {deleteModalState && (
        <DeleteModal
          setUpdateState={setUpdateState}
          upComingData={upComingData}
        />
      )}
    </>
  );
};

export default Upcoming;
